import TagTimeline from "./TagTimeline";
// import { GENERATE_URL } from "./helpers/request.js";

import Account from "./Account";
import Admin from "./Admin";
import BankAccount from "./BankAccount";
import Company from "./Company";
import Customer from "./Customer";
import CustomerUser from "./CustomerUser";
import Discount from "./Discount";
import DiscountRule from "./DiscountRule";
import Device from "./Device";
import Employee from "./Employee";
import Export from "./Export";
import ExtraProduct from "./ExtraProduct";
import ExtraProductRule from "./ExtraProductRule";
import File from "./File";
import GoogleMap from "./GoogleMap";
import Note from "./Note";
import Notification from "./Notification";
import PaymentMethod from "./PaymentMethod";
import PaymentSetting from "./PaymentSetting";
import Plan from "./Plan";
import PlanDefinition from "./PlanDefinition";
import PlanInterval from "./PlanInterval";
import MeetingResult from "./MeetingResult";
import MeetingRecord from "./MeetingRecord";
import Product from "./Product";
import ProductCustomPrice from "./ProductCustomPrice";
import OneTimeProductName from "./OneTimeProductName";
import ProductCategory from "./ProductCategory";
import Region from "./Region";
import Location from "./Location";
import Sale from "./Sale";
import Setting from "./Setting";
import ShoppingBasket from "./ShoppingBasket";
import BillOperation from "./BillOperation";
import SaleNote from "./SaleNote";
import SpecialDiscount from "./SpecialDiscount";
import Statistic from "./Statistic";
import EmployeeTracking from "./EmployeeTracking";
import SaleTarget from "./SaleTarget";
import CustomerReport from "./CustomerReport";
import CustomerReportQuestion from "./CustomerReportQuestion";
import CustomerReportResult from "./CustomerReportResult";
import CustomerReportResultAnswer from "./CustomerReportResultAnswer";
import Transactions from "./Transactions";
import CollectionReport from "./CollectionReport";
import ParasutSync from "./ParasutSync";
import MikroSync from "./MikroSync";
import MikroAccount from "./MikroAccount";
import UserLog from "./UserLog";
import ProductCategoryRegionCoefficient from "./ProductCategoryRegionCoefficient";
import TagGroup from "./TagGroup";
import Tag from "./Tag";
import TagRule from "./TagRule";
import SaleStatus from "./SaleStatus";
import SaleDocument from "./SaleDocument";
import Backfill from "./Backfill";
import CrmCustomer from "./CrmCustomer";
import CrmCustomerReport from "./CrmCustomerReport";
import CrmDashboard from "./CrmDashboard";
import Workspace from "./Workspace";
import LeadSource from "./LeadSource";
import LeadImport from "./LeadImport";
import ProductBrand from "./ProductBrand";
import CompanyIntegrationConnection from "./CompanyIntegrationConnection";
import CrmSaleReport from "./CrmSaleReport";
import LeadAdvertisementReport from "./LeadAdvertisementReport";
import Subscription from "./Subscription";
import EInvoiceCompany from "./EInvoiceCompany";
import EInvoiceRecipient from "./EInvoiceRecipient";
import EInvoice from "./EInvoice";
import CreditCard from "./CreditCard";
import PaymentTermRule from "./PaymentTermRule";
// FOR V1
import CustomerV1 from "./v1/Customer";
import EmployeeV1 from "./v1/Employee";
import ProductV1 from "./v1/Product";

// Mobile App
import Events from "./MobileApp/Events";
import MoneyPoint from "./MobileApp/MoneyPoint";
import Deeplink from "./MobileApp/Deeplink";
import Topics from "./MobileApp/Topics";
import CustomerUsers from "./MobileApp/CustomerUsers";

export default {
  TagTimeline,
  v1: {
    Customer: CustomerV1,
    Employee: EmployeeV1,
    Product: ProductV1,
  },
  Account,
  Admin,
  Region,
  Location,
  Plan,
  Sale,
  Setting,
  ShoppingBasket,
  BillOperation,
  File,
  Customer,
  Notification,
  Note,
  SaleNote,
  SpecialDiscount,
  Product,
  ProductCustomPrice,
  OneTimeProductName,
  Export,
  GoogleMap,
  BankAccount,
  Company,
  Employee,
  CustomerUser,
  PaymentMethod,
  PaymentSetting,
  PlanDefinition,
  PlanInterval,
  MeetingResult,
  MeetingRecord,
  ProductCategory,
  ExtraProduct,
  ExtraProductRule,
  Discount,
  DiscountRule,
  Device,
  Statistic,
  EmployeeTracking,
  SaleTarget,
  CustomerReport,
  CustomerReportQuestion,
  CustomerReportResult,
  CustomerReportResultAnswer,
  Transactions,
  CollectionReport,
  ParasutSync,
  MikroSync,
  MikroAccount,
  UserLog,
  ProductCategoryRegionCoefficient,
  TagGroup,
  Tag,
  TagRule,
  SaleStatus,
  SaleDocument,
  Backfill,
  CrmCustomer,
  CrmCustomerReport,
  CrmDashboard,
  Workspace,
  LeadSource,
  LeadImport,
  ProductBrand,
  CompanyIntegrationConnection,
  LeadAdvertisementReport,
  CrmSaleReport,
  Subscription,
  EInvoiceCompany,
  EInvoiceRecipient,
  EInvoice,
  CreditCard,
  PaymentTermRule,
  MobileApp: {
    Events,
    MoneyPoint,
    Deeplink,
    Topics,
    CustomerUsers,
  },
};
